import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const api = collectionEngineV1('/payouts');
export const get = (filter, page, pageSize) => api('GET', `/?${toQuery({ page, pageSize, ...filter })}`);
export const getById = (id) => api('GET', `/${id}`);
export const create = (payout) => api('POST', `/`, {
    body: payout,
});
export const update = (id, payout) => api('PATCH', `/${id}`, {
    body: payout,
});
//# sourceMappingURL=payouts.js.map